/**
 * Available indexes reducer.
 * @module reducers/availableIndexes/availableIndexes
 */

import {
  GET_AVAILABLE_INDEXES,
  AVAILABLE_INDEXES_CLEAR_SSR,
} from '@fhnw/constants/ActionTypes';

const initialState = {
  error: null,
  available_indexes: {},
  active_query: [],
  loaded: false,
  loading: false,
  subrequests: {},
};

/**
 * Available indexes reducer.
 * @function availableIndexes
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export default function availableIndexes(
  state: any = initialState,
  action: any = {},
) {
  switch (action.type) {
    case `${GET_AVAILABLE_INDEXES}_PENDING`:
      return action.subrequest
        ? {
            ...state,
            subrequests: {
              ...state.subrequests,
              [action.subrequest]: {
                ...(state.subrequests[action.subrequest] || {
                  available_indexes: {},
                  active_query: [],
                }),
                available_indexes: {},
                active_query: [],
                error: null,
                loaded: false,
                loading: true,
              },
            },
          }
        : {
            ...state,
            error: null,
            loading: true,
            loaded: false,
          };
    case `${GET_AVAILABLE_INDEXES}_SUCCESS`:
      return action.subrequest
        ? {
            ...state,
            subrequests: {
              ...state.subrequests,
              [action.subrequest]: {
                error: null,
                available_indexes: action.result.available_indexes,
                active_query: action.result.active_query,
                loaded: true,
                loading: false,
                isSSR: action.isSSR,
              },
            },
          }
        : {
            ...state,
            error: null,
            available_indexes: action.result.available_indexes,
            active_query: action.result.active_query,
            loaded: true,
            loading: false,
            isSSR: action.isSSR,
          };
    case `${GET_AVAILABLE_INDEXES}_FAIL`:
      return action.subrequest
        ? {
            ...state,
            subrequests: {
              ...state.subrequests,
              [action.subrequest]: {
                error: action.error,
                available_indexes: {},
                active_query: [],
                loaded: false,
                loading: false,
              },
            },
          }
        : {
            ...state,
            error: action.error,
            available_indexes: {},
            active_query: [],
            loaded: false,
            loading: false,
          };
    case AVAILABLE_INDEXES_CLEAR_SSR:
      return action.subrequest
        ? {
            ...state,
            subrequests: {
              ...state.subrequests,
              [action.subrequest]: {
                ...state.subrequests[action.subrequest],
                isSSR: false,
              },
            },
          }
        : {
            ...state,
            isSSR: false,
          };
    default:
      return state;
  }
}
